import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { service } from '@ember/service';

import { partnerBaseURL, partnerNamespace } from 'register-partners-js/constants/hosts';

export default class ApplicationAdapter extends JSONAPIAdapter {
  @service networkManager;

  host = partnerBaseURL;
  namespace = partnerNamespace;
  useFetch = true;

  get headers() {
    return this.networkManager.requestHeaders;
  }

  ajaxOptions() {
    let options = super.ajaxOptions(...arguments);
    options.credentials = 'include';
    return options;
  }
}
